<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Forbidden</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"><a id="page_i"></a> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="half-title">The F<span class="small">ORBIDDEN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?6b81b998